// extracted by mini-css-extract-plugin
export default {"text":"PJt_zn","lineClamp":"opqVoB"};